import { useState } from 'react';
import { useWindowSize } from 'react-use';
import { isMobileBrowser } from '../../common/utils';
import AddFloorPlanButton from '../../components/AddFloorPlanButton';
import AllFloorPlans from '../vastu-assessment-report/AllFloorPlans';

//Import css
import './dashboard.less';

export default function Dashboard() {
  const { width } = useWindowSize();
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = (scrolled: boolean) => {
    setIsScrolled(scrolled);
  };

  return (
    <div>
      <AllFloorPlans onScrollChange={handleScroll} />
      {isScrolled && <AddFloorPlanButton />}
      {isMobileBrowser(width) && <AddFloorPlanButton />}
    </div>
  );
}
